import React, { useState, useEffect } from "react";

import QRCode from "react-qr-code";

import VuiBox from "components/VuiBox";
import VuiButtonCustom from "components/VuiButtonCustom";
import VuiLabel from "components/VuiLabel";
import colors from "assets/theme/base/colors";

import moment from "moment";

import {
  DashboardGrid,
  ServerHeader,
  ServerName,
  ServerDomain,
  ServerStatus,
  ServerStatusHeader,
  ServerStatusOnline,
  ServerStatusOffline,
  InfoRow,
  InfoLabel,
  InfoValue,
} from "./styles";

function rulesHostNameColor(hostname) {
  if (hostname && (hostname.substr(0, 3) === "NT-" || hostname.substr(0, 3) === "PC-")) {
    return "#0f1535";
  }
  return "#bd0000";
}

function macToId(mac) {
  // 1-F44D-308C-BC64-1
  //   0123-4567-8901
  let blocksMac = mac.split(":");

  console.log(">>>", blocksMac);

  blocksMac =
    blocksMac[0] +
    blocksMac[1] +
    "-" +
    blocksMac[2] +
    blocksMac[3] +
    "-" +
    blocksMac[4] +
    blocksMac[5];

  console.log(">>>", blocksMac);

  return "1-" + blocksMac.toLowerCase() + "-1";
}

function VuiInfoItemControllers({ item, index }) {
  const [isOpenModal, setIsOpenModal] = useState(false);

  if (item) {
    return (
      <>
        <DashboardGrid>
          <ServerHeader>
            <ServerStatusHeader>
              <ServerName color={rulesHostNameColor(item?.initials)}>
                {item?.initials?.toLowerCase()}.seap.ma.br
              </ServerName>
            </ServerStatusHeader>

            <ServerStatus>
              {item.status === 1 ? (
                <ServerStatusOnline>Online</ServerStatusOnline>
              ) : (
                <ServerStatusOffline>Offline</ServerStatusOffline>
              )}
            </ServerStatus>
          </ServerHeader>

          <InfoRow>
            <InfoLabel>Unidade:</InfoLabel>
            <InfoValue>{item?.initials}</InfoValue>
          </InfoRow>

          <InfoRow>
            <InfoLabel>IP:</InfoLabel>
            <InfoValue>{item?.ipAddress}</InfoValue>
          </InfoRow>

          <InfoRow>
            <InfoLabel>MAC:</InfoLabel>
            <InfoValue>{item?.macAddress}</InfoValue>
          </InfoRow>

          <InfoRow>
            <InfoLabel>Fabricante:</InfoLabel>
            <InfoValue>{item?.brandName}</InfoValue>
          </InfoRow>

          <InfoRow>
            <InfoLabel>Modelo:</InfoLabel>
            <InfoValue>{item?.modelName}</InfoValue>
          </InfoRow>

          <InfoRow>
            <InfoLabel>S/N:</InfoLabel>
            <InfoValue>{item?.hostname}</InfoValue>
          </InfoRow>

          <InfoRow>
            <InfoLabel>Localização:</InfoLabel>
            <InfoValue>{item?.comment}</InfoValue>
          </InfoRow>

          {item.status && (
            <>
              <InfoRow>
                <InfoLabel>Latência:</InfoLabel>
                <InfoValue>{item?.max} ms</InfoValue>
              </InfoRow>

              <VuiLabel />
            </>
          )}

          <InfoRow>
            <InfoLabel>{item.status ? "Última atualização" : "Falha da conexão desde"}</InfoLabel>
            <InfoValue>{item.updatedAt}</InfoValue>
          </InfoRow>

          {!item.status ? (
            <InfoRow>
              <InfoLabel>Última atualização</InfoLabel>
              <InfoValue>{item.lastUpdatedAt}</InfoValue>
            </InfoRow>
          ) : (
            <VuiLabel />
          )}

          {/* <VuiLabel /> */}
        </DashboardGrid>
      </>
    );
  }
}

export default VuiInfoItemControllers;
